module.exports = __webpack_public_path__ + "media/images/gallery/5-59297d6c519bed6c69748c510835f9aa.jpg";